export default {"src":"/_next/static/media/10_points_icon.40030545.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};